import { useAppStore } from '../../shared/store/store'
import { Object3D } from 'three'
import { useEffect } from 'react'

export const ExposeStateAndModel = ({
  model,
  sku,
}: {
  model: Object3D | undefined
  sku: string
}) => {
  window.ExposedStateBySKU = window.ExposedStateBySKU ?? {}
  window.ExposedModelBySKU = window.ExposedModelBySKU ?? {}

  window.ExposedStateBySKU[sku] = useAppStore((state) => state)
  window.ExposedModelBySKU[sku] = model

  useEffect(() => {
    return () => {
      window.ExposedStateBySKU[sku] = null
      window.ExposedModelBySKU[sku] = null
    }
  }, [])
  return null
}
